const Mail = ({ stroke = "currentColor", ...p }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
    {...p}
  >
    <rect
      x="2"
      y="3.5"
      width="12"
      height="9"
      rx="1.2"
      stroke={stroke}
      strokeWidth="1.4"
    />
    <path
      d="M2.5 4.5l5.5 4 5.5-4"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Mail;
